/**
 * Who Omni asks about Pippi. cowork decides (GET /v1/pippi/me: staff with a verified Beatly address, the BO's own
 * admin session, the named test accounts); Omni only spares everyone else the call: it asks for a Beatly address or an
 * admin session, never in the BO's frame (the BO has its own Pippi). VITE_PIPPI_ASK_ALL=true asks for everyone (the
 * client beta, when it opens).
 */
import { isAdminShapedToken } from '@/utils/auth';

export function mayAskForPippi(user: { email?: string | null } | null | undefined, token: string | null | undefined, opts: { embed?: boolean; askAll?: boolean } = {}): boolean {
  if (!user || opts.embed) return false;
  if (opts.askAll) return true;
  return /@beatly\.com$/i.test(String(user.email || '').trim()) || isAdminShapedToken(token);
}
